import { Grid, styled, Typography } from '@mui/material'

export const Wrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  minHeight: 0,
  height: 0,
  width: '100%',
  margin: theme.spacing(2, 0),
  overflow: 'hidden',
}))

export const SearchRow = styled(Grid)(({ theme }) => ({
  flex: '0 0 auto',
  paddingTop: theme.spacing(1),
}))

export const ScrollArea = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 0',
  minHeight: 0,
  width: '100%',
  overflowX: 'hidden',
  overflowY: 'auto',
})

export const PaginationWrapper = styled('div')(({ theme }) => ({
  flex: '0 0 auto',
  width: '100%',
  marginTop: 'auto',
  paddingTop: theme.spacing(1),
}))

export const NoResults = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '1 1 auto',
  minHeight: 0,
  padding: theme.spacing(2),
  boxSizing: 'border-box',
  color: theme.palette.text.secondary,
  textAlign: 'center',
}))
